// External Imports
import { useContext } from "react";

// Internal Imports
import { UtilityContext } from "../../context/util-context";
import TierLabel from "../UI/TierLabel";
import CustomerFlags from "./CustomerFlags";
import { isoDateToString } from "../../util/format-date";

/** ========================================================================
 * * Customer Card Component
  * Renders a card displaying customer information.
 * ========================================================================== */

export default function CustomerCard({ customer }) {
  const { navigate } = useContext(UtilityContext);

  const classNames = () => {
    let classes = "grid items-center gap-4 text-sm lg:grid-cols-8 pill ";
    if (customer.plan?.name === "LUXURY") classes += `border-sky-500`;
    if (customer.plan?.name === "PLUSH") classes += `border-emerald-500`;
    if (customer.plan?.name === "POSH") classes += `border-orange-500`;
    return classes;
  };

  return (
    <div
      onClick={(e) => navigate(`/customers/info?id=${customer.id}`, e)}
      className={classNames()}
    >
      <div className="flex items-center space-x-4 lg:col-span-2">
        {customer.photo  && <img src={customer.photo} className="w-10 h-10 rounded-full"/>}
        <p className="font-semibold text-stone-200">
          {customer.firstName} {customer.lastName}
        </p>
      </div>
      <div className="text-center lg:text-left lg:col-span-2">
        <p className="text-stone-200">{customer.phone || "-"}</p>
        <p className="text-stone-200">{customer.email}</p>
      </div>
      <div className="hidden lg:col-span-2 lg:block">
        <p className="font-semibold text-stone-200">
          {customer.booking?.vehicle
            ? `${customer.booking.vehicle.year} ${customer.booking.vehicle.make.name} ${customer.booking.vehicle.model} ${customer.booking.vehicle.vin.substring(13, 17)}`
            : "-"}
        </p>
        <p className="text-stone-400">
          {customer.booking ? `${isoDateToString(customer.booking.startDate)} - ${isoDateToString(customer.booking.endDate)}` : "-"}
        </p>
      </div>
      <div className="hidden text-center lg:block">
        <p>{customer.advisor?.name || "-"}</p>
      </div>
      <CustomerFlags customer={customer} />
    </div>
  );
}
